
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton, AppImageHolder } from '@/components';
import { useCollectionDetail } from '@/modules/collection/model/detail';
import { CollectionSelectOptions, CollectionType } from '@/modules/collection/types';
import { ROUTE_NAME_COLLECTION } from '@/modules/collection/router';
import { renderOption } from '@/common/utils/helpers';

export default defineComponent({
    name: 'CollectionDetail',
    components: { AppCard, AppButton, AppImageHolder },
    setup() {
        const { model, fetch, actions } = useCollectionDetail();

        onMounted(fetch);

        return { model, actions, ROUTE_NAME_COLLECTION, CollectionType, CollectionSelectOptions, renderOption };
    }
});
